import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=45b65b52&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=45b65b52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b65b52",
  null
  
)

export default component.exports